import { render, staticRenderFns } from "./GroupReceptionForm.vue?vue&type=template&id=35fb4dd2&scoped=true"
import script from "./GroupReceptionForm.vue?vue&type=script&lang=js"
export * from "./GroupReceptionForm.vue?vue&type=script&lang=js"
import style0 from "./GroupReceptionForm.vue?vue&type=style&index=0&id=35fb4dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb4dd2",
  null
  
)

export default component.exports